<template>
    <rkm-form
        v-if="model && form"
        ref="Form"
        show-legend
    >
        <rkm-area>
            <rkm-row>
                <rkm-col cols="2">
                    <rkm-form-select
                        label="Status"
                        :options="form.status"
                        text-field="descricao"
                        value-field="id"
                        v-model="model.status"
                        @change="handleStatus"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-date-picker
                        label="Data"
                        @input="handleData"
                        v-model="model.data"
                        :validations="validations.data"
                        :max-date="form.dataAtual"
                        right
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-select
                        label="Veículo"
                        :options="form.veiculos"
                        @change="handelVeiculo"
                        text-field="descricao"
                        value-field="id"
                        show-default-option
                        v-model="model.veiculoId"
                        :validations="validations.veiculo"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-select
                        label="Motorista"
                        :options="form.motoristas"
                        @change="handleMotorista"
                        text-field="nome"
                        value-field="id"
                        show-default-option
                        v-model="model.motoristaId"
                        :validations="validations.motorista"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="2">
                    <rkm-form-select
                        :options="form.horarios"
                        label="Horário de saída"
                        show-default-option
                        default-option-text="Todos"
                        text-field="horario"
                        v-model="model.horario"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-button
                        color="primary"
                        @click="handleSearch"
                        :label="false"
                    >
                        Buscar
                    </rkm-button>

                    <rkm-button
                        color="secondary"
                        @click="handleClear"
                        :label="false"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area title="Fechamento da viagem" v-if="model.id">
            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-time-picker
                        label="Horário de saída"
                        v-model="model.horarioSaida"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-time-picker
                        label="Horário de chegada ao destino"
                        v-model="model.horarioChegadaDestino"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-time-picker
                        label="Horário de saida do destino"
                        v-model="model.horarioSaidaDestino"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-date-picker
                        label="Data de chegada"
                        v-model="model.dataChegada"
                        right
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-time-picker
                        label="Horário de chegada"
                        v-model="model.horarioChegada"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        label="KM de saída"
                        v-model="model.kmSaida"
                        :validations="validations.kmSaida"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        label="KM de chegada"
                        v-model="model.kmChegada"
                        :validations="validations.kmChegada"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        label="Protocolo"
                        v-model="model.protocolo"
                        disabled
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area title="Despesas" v-if="model.id">
            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        label="Diária"
                        v-model="model.diaria"
                        v-money="money"
                        prepend="R$"
                        :validations="validations.diaria"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-input
                        label="Refeição"
                        v-model="model.refeicao"
                        v-money="money"
                        prepend="R$"
                        :validations="validations.refeicao"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-input
                        label="Pernoite"
                        v-model="model.pernoite"
                        v-money="money"
                        prepend="R$"
                        :validations="validations.pernoite"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-input
                        label="Pedágio"
                        v-model="model.pedagio"
                        v-money="money"
                        prepend="R$"
                        :validations="validations.pedagio"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-input
                        label="Combustível"
                        v-model="model.combustivel"
                        v-money="money"
                        prepend="R$"
                        :validations="validations.combustivel"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        label="Outras despesas"
                        v-model="model.outrasDespesas"
                        v-money="money"
                        prepend="R$"
                        :validations="validations.outrasDespesas"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-input
                        label="Descrição de outras despesas"
                        v-model="model.descricaoOutrasDespesas"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-input
                        label="Total despesas"
                        :value="total"
                        prepend="R$"
                        disabled
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area title="Fechamento de pacientes" v-if="pacientes && model.id">
            <rkm-table
                :fields="fields"
                :items="pacientes"
                hide-filters
                hide-pagination
            >
                 <template v-slot:cell(situacao)="{ item }">
                    <rkm-form-select
                        :options="form.situacao"
                        text-field="descricao"
                        value-field="id"
                        v-model="item.situacao"
                    />
                </template>

                <template v-slot:cell(nomeStatus)="{ item }">
                    <span v-if="item.viagemStatusId === enums.status.ABERTO">
                        ABERTO
                    </span>
                    <span v-else-if="item.viagemStatusId === enums.status.FINALIZADO">
                        FINALIZADO
                    </span>
                </template>
            </rkm-table>
        </rkm-area>
    </rkm-form>
</template>

<script>
import { error, repository, stringCase } from "@/mixins";

import status from "@/enums/transporte-paciente/status"

import { mapActions } from "vuex";

import moment from "moment"

import { VMoney } from 'v-money'

export default {
    directives: { money: VMoney },
    mixins: [error, repository, stringCase],
    computed: {
        total() {
            return [
                this.model.diaria,
                this.model.refeicao,
                this.model.pernoite,
                this.model.pedagio,
                this.model.combustivel,
                this.model.outrasDespesas
            ].reduce((total, despesa) => despesa ? total + this.parseValue(despesa) : total, 0.0).toFixed(2)
        },
        validations() {
            return {
                data: {
                    required: true,
                },
                veiculo: {
                    required: true,
                },
                motorista: {
                    required: true,
                },
                horario: {
                    required: true,
                },
                kmSaida: {
                    max: 6,
                },
                kmChegada: {
                    max: 6,
                },
                diaria: {
                    min_value: 0,
                },
                refeicao: {
                    min_value: 0,
                },
                pedagio: {
                    min_value: 0,
                },
                combustivel: {
                    min_value: 0,
                },
                outrasDespesas: {
                    min_value: 0,
                }
            }
        },
        fields() {
            return [
                {
                    key: 'nome',
                    label: 'Nome',
                },
                {
                    key: 'dataNasc',
                    label: 'Data nasc.',
                },
                {
                    key: 'localConsulta',
                    label: 'Local consulta',
                },
                {
                    key: 'motivo',
                    label: 'Motivo',
                },
                {
                    key: 'situacao',
                    label: 'Situação',
                },
                {
                    key: 'nomeStatus',
                    label: 'Status da viagem',
                    class: 'text-center'
                },
            ]
        },
    },
    data: () => ({
        model: null,
        form: null,
        pacientes: null,
        enums: {
            status
        },
        money: {
            decimal: ',',
            thousands: '.',
            suffix: '',
            precision: 2,
            masked: false
        },
    }),
    methods: {
        ...mapActions(["setLoading", "unsetLoading"]),
        handleStatus() {

            this.model.veiculoId = null
            this.model.motoristaId = null
            this.model.horario = null
            this.model.id = null
            this.pacientes = null

            if(this.model.data) {
                this.setLoading()
                this.repositories.fechamentoViagem.veiculos({
                    data: moment(this.model.data).format("YYYY-MM-DD"),
                    status: this.model.status,
                })
                .then(({data}) => {
                    this.form.veiculos = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
            }
        },
        handleData() {
            if(this.model.data) {


                this.setLoading()
                this.repositories.fechamentoViagem.veiculos({
                    data: moment(this.model.data).format("YYYY-MM-DD"),
                    status: this.model.status,
                })
                .then(({data}) => {
                    this.form.veiculos = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
            }
        },
        handelVeiculo() {

            this.model.motoristaId = null
            this.model.horario = null
            this.model.id = null
            this.pacientes = null

            if(this.model.veiculoId) {
                this.setLoading()
                this.repositories.fechamentoViagem.motoristas({
                    data: moment(this.model.data).format("YYYY-MM-DD"),
                    veiculo_id: this.model.veiculoId,
                    status: this.model.status,
                })
                .then(({data}) => {
                    this.form.motoristas = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
            }
        },
        handleMotorista() {

            if (this.model.motoristaId) {
                this.setLoading();
                this.repositories.fechamentoViagem.horarios({
                    data: moment(this.model.data).format("YYYY-MM-DD"),
                    motorista_id: this.model.motoristaId,
                    veiculo_id: this.model.veiculoId,
                    status: this.model.status,
                })
                .then(({ data }) => {
                    if (data.some(d => d.horarioSaidaTemp !== null)) {
                        this.form.horarios = data
                            .filter((d, index, self) =>
                                d.horarioSaidaTemp !== null ||
                                self.findIndex(t => t.horarioSaidaTemp === null) === index
                            )
                            .map(d => ({
                                id: d.id,
                                horario: d.horarioSaidaTemp
                            }));
                    } else {
                        this.form.horarios = []
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading());
            }
        },
        handleSearch() {
            this.$refs.Form.validate().then(valid => {
                if(!valid) return
                this.setLoading()
                this.repositories.fechamentoViagem.search({
                    id: this.model.horario,
                    data: moment(this.model.data).format("YYYY-MM-DD"),
                    motorista_id: this.model.motoristaId,
                    veiculo_id: this.model.veiculoId,
                    status: this.model.status,
                    horario: this.model.horario,
                })
                .then(({data}) => {
                    this.setViagem(data.viagem)
                    this.setPacientes(data.pacientes)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
            })
        },
        setViagem(viagem) {

            this.model.id = viagem.id
            this.model.horarioSaida = viagem.horarioSaidaReal
            this.model.horarioChegadaDestino = viagem.horarioChegadaDestino
            this.model.horarioSaidaDestino = viagem.horarioSaidaDestino
            this.model.dataChegada = viagem.dataChegada
            this.model.horarioChegada = viagem.horarioChegada
            this.model.kmSaida = viagem.kmSaida
            this.model.kmChegada = viagem.kmChegada
            this.model.diaria = viagem.diaria
            this.model.refeicao = viagem.refeicao
            this.model.pernoite = viagem.pernoite
            this.model.pedagio = viagem.pedagio
            this.model.combustivel = viagem.combustivel
            this.model.outrasDespesas = viagem.outrasDespesas
            this.model.descricaoOutrasDespesas = viagem.descricaoOutrasDespesas
            this.model.totalDespesas = viagem.totalDespesas
            this.model.protocolo = viagem.protocolo ? viagem.protocolo : '-'
        },
        setPacientes(pacientes) {
            this.pacientes = pacientes
        },
        handleClear() {
            this.form.veiculos = []
            this.form.motoristas = []
            this.form.horarios = []
            this.model.id = null
            this.model.data = null
            this.model.veiculoId = null
            this.model.motoristaId = null
            this.model.horario = null
            this.pacientes = null
            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        load() {
            this.setLoading()
            this.repositories.fechamentoViagem.index()
                .then(({data}) => {
                    this.setData(data.form, data.model)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        setData(form, model) {
            if(form) {
                this.form = Object.assign(form)
            }
            if(model) {
                this.model = Object.assign(model)
            }
        },
        save() {
            if(this.model.id){
                this.setLoading()

                this.repositories.fechamentoViagem.update(this.model.id, this.prepareData())
                    .then(() => {
                        this.showSaveNotification()
                        this.handleClear()
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            } else {
                this.showAlert('Busque uma viagem.', 'Atenção')
            }
        },
        parseValue($value) {
            return parseFloat($value.replace('.', '').replace(',', '.'))
        },
        prepareData() {
            return {
                viagem: {
                    status_id: this.enums.status.FINALIZADO,
                    horario_saida_real: this.model.horarioSaida,
                    horario_chegada_destino: this.model.horarioChegadaDestino,
                    horario_saida_destino: this.model.horarioSaidaDestino,
                    data_chegada: this.model.dataChegada ? moment(this.model.dataChegada).format("YYYY-MM-DD") : null,
                    horario_chegada: this.model.horarioChegada,
                    km_saida: this.model.kmSaida,
                    km_chegada: this.model.kmChegada,
                    diaria: this.parseValue(this.model.diaria),
                    refeicao: this.parseValue(this.model.refeicao),
                    pernoite: this.parseValue(this.model.pernoite),
                    pedagio: this.parseValue(this.model.pedagio),
                    combustivel: this.parseValue(this.model.combustivel),
                    outras_despesas: this.parseValue(this.model.outrasDespesas),
                    descricao_outras_despesas: this.model.descricaoOutrasDespesas,
                    total_despesa: this.total,
                },
                pacientes: this.pacientes.map(paciente => {

                    return {
                        id: paciente.id,
                        status_id: paciente.situacao,
                        destino_id: paciente.destinoId,
                        procedimento_id: paciente.procedimentoId,
                        lotacao_id: paciente.lotacaoId,
                        ocupacao_id: paciente.ocupacaoId,
                        quantidade: paciente.quantidade,
                        paciente_id: paciente.pacienteId,
                        motivo_id: paciente.motivoId,
                        distancia: paciente.distancia,
                        usuario_id: paciente.usuarioId,
                        quantidade_acompanhante: paciente.quantidadeAcompanhante,
                        idade: paciente.idade,
                        acompanhante_1: paciente.acompanhanteUsuarioId_1 ?? null,
                        acompanhante_2: paciente.acompanhanteUsuarioId_2 ?? null,
                    }
                })
            }
        },
    },
    created() {
        this.repositories = {
            fechamentoViagem: this.getConectaSusRepository("transportePaciente.fechamentoViagem")
        }
    },
    mounted() {
        this.load()
    },
    watch: {
        'model.status': function() {
            this.form.motoristas = []
            this.form.horarios = []
            this.model.id = null
            this.model.veiculoId = null
            this.model.motoristaId = null
            this.model.horario = null
            this.pacientes = null
            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        'model.data': function() {
            this.form.motoristas = []
            this.form.horarios = []
            this.model.id = null
            this.model.veiculoId = null
            this.model.motoristaId = null
            this.model.horario = null
            this.pacientes = null
            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        'model.veiculoId': function() {
            this.form.horarios = []
            this.model.id = null
            this.model.motoristaId = null
            this.model.horario = null
            this.pacientes = null
            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        'model.motoristaId': function() {
            this.model.id = null
            this.model.horario = null
            this.pacientes = null
            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        'model.horario': function() {
            this.model.id = null
            this.pacientes = null
            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        }
    }
}
</script>